// Created by hejikun on 2017/10/25 0025.
let state = {
  physicalExamination: {},
  phy_hasMore: true, // 加载更多状态:,
  package_list: []
}

const actions = {
  // 获取列表
  loadPhysicalExaminationList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'package_list': // 获取医院列表
        url = `check/package?page=${args.page}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res.data.code === 1
          ? (() => {
              commit({
                type: 'set_PhysicalExamination_list',
                dataType: args.type,
                data: res.data.data,
                page: args.page
              })
            })()
          : commit({
              type: 'set_PhysicalExamination_list',
              dataType: args.type,
              data: [],
              page: args.page
            })
        return Promise.resolve(res.data.data)
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const getters = {}

const mutations = {
  set_PhysicalExamination_list(state, args) {
    args.data.length < 10 ? (state.phy_hasMore = false) : (state.phy_hasMore = true)
    if (args.page === 1) {
      if ( args.data.length === 0) {
        state[args.dataType] = []
      } else {
        state[args.dataType] = args.data
      }
    } else {
      if (args.data.length !== 0) {
        args.data.forEach((item) => {
          state[args.dataType].push(item)
        })
      }
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
